import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SubscriptionListItem } from './subscription-list-item.model';

@Component({
  selector: 'shared-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrl: './subscription-list.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionListComponent {
  @Input() items: SubscriptionListItem[] = [];
  @Output() readonly itemClick = new EventEmitter<SubscriptionListItem>();
}
